<div>
	<img
		*ngIf="!hideBanner && bannerKey"
		class="obg-m-content-section-group-banner"
		[obgImageContent]="bannerKey"
		obgImageContentGroup="common"
	/>
	<h5 *ngIf="subtitle">{{ subtitle }}</h5>
	<obg-content-section-group
		[contentSections]="contentSections"
		[anchorLinksVisible]="anchorLinksVisible"
		[seoEnabled]="seoEnabled"
		[hideTitles]="hideTitles"
		[enableTableFormatting]="enableTableFormatting"
	>
	</obg-content-section-group>
</div>
